import type { IAppRegion } from '~/lib/appSettings';

export const getRegionFromPath = (path: string): IAppRegion | undefined =>
  path === 'dev-us' || path === 'us' || path === 'fr'
    ? `crowdaa-${path}`
    : undefined;
